var render = function () {
  var _vm$$slots;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup__container",
    class: _vm.additionalPopupClasses
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "25",
      "viewBox": "0 0 24 25",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12.0002 21.3C16.8603 21.3 20.8002 17.3601 20.8002 12.5C20.8002 7.63984 16.8603 3.69995 12.0002 3.69995C7.14009 3.69995 3.2002 7.63984 3.2002 12.5C3.2002 17.3601 7.14009 21.3 12.0002 21.3ZM12.0002 23.2999C17.9649 23.2999 22.8002 18.4646 22.8002 12.5C22.8002 6.53528 17.9649 1.69995 12.0002 1.69995C6.03552 1.69995 1.2002 6.53528 1.2002 12.5C1.2002 18.4646 6.03552 23.2999 12.0002 23.2999Z",
      "fill": "white"
    }
  }), _c('path', {
    attrs: {
      "d": "M13 18.5C13 19.0523 12.5523 19.5 12 19.5C11.4477 19.5 11 19.0523 11 18.5C11 17.9477 11.4477 17.5 12 17.5C12.5523 17.5 13 17.9477 13 18.5Z",
      "fill": "white"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12 15.6648C11.4477 15.6648 11 15.2171 11 14.6648L11 7.33479C11 6.78251 11.4477 6.33479 12 6.33479C12.5523 6.33479 13 6.78251 13 7.33479L13 14.6648C13 15.2171 12.5523 15.6648 12 15.6648Z",
      "fill": "white"
    }
  })]), _c('div', {
    staticClass: "popup-info"
  }, [_vm.title ? _c('p', {
    staticClass: "popup-info__title"
  }, [_vm._t("title", function () {
    return [_vm._v(_vm._s(_vm.title))];
  }, null, {
    title: _vm.title
  })], 2) : _vm._e(), _vm.description ? _c('p', {
    staticClass: "popup-info__description"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()]), (_vm$$slots = _vm.$slots) !== null && _vm$$slots !== void 0 && _vm$$slots.footer ? _c('div', {
    staticClass: "popup-footer"
  }, [_vm._t("footer")], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }